import { setTag } from "@sentry/react";
import React, { useEffect, useReducer } from "react";
import { useLocation } from "react-router";
import AppContext, { getInitialState } from "src/app/AppContext";
import {
  NO_AUTH_PUBLICATION,
  PublicationShortname,
} from "src/app/auth/serviceIdentifier";
import reducer, { Actions } from "src/app/reducer";
import { fetchVisitorContext } from "src/trackers/viewerContext";

type Props = {
  children: React.ReactElement;
};

const SENTRY_PUBS_TAG_KEY = "sph:pubID";

export default function AppContextHOC({ children }: Props): React.ReactElement {
  const [state, dispatch] = useReducer(reducer, getInitialState());

  const location = useLocation();

  useEffect(() => {
    if (state.pubId !== PublicationShortname.DEFAULT) {
      setTag(SENTRY_PUBS_TAG_KEY, state.pubId);
    }

    if (
      state.pubId !== PublicationShortname.DEFAULT &&
      !NO_AUTH_PUBLICATION.includes(state.pubId)
    ) {
      void (async function () {
        await getVisitorContext(state.pubId);
      })();
    }
  }, [state.pubId, location]);

  const getVisitorContext = async (
    pubsId: PublicationShortname,
  ): Promise<void> => {
    try {
      const visitorContext = await fetchVisitorContext(pubsId);
      dispatch({
        type: Actions.SET_VIEWERCONTEXT,
        payload: { visitorContext },
      });
    } catch (error: unknown) {
      console.error("failed to get viewerContext :: ", error);
    }
  };

  return (
    <AppContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      <div data-theme={state.pubId}>{children}</div>
    </AppContext.Provider>
  );
}
